/* KAARKASH editorial collection page (sections/kk-collection).
   - Pictures to a row: two views, the choice kept for the next visit.
   - More pieces arrive as the end of the grid comes near. The numbered pages stay in the
     page and are only put away once the script knows how many pages there are.
   - Filter & Sort: a panel from the right. The filtering itself is the theme's
     (assets/facets.js); this opens and closes the panel, keeps the keyboard inside it, and
     puts the grid back in order each time the theme swaps its contents.
   - Cards further down the page rise into place as they come on screen; the second
     photograph of a card is fetched the first time the pointer comes over it. */
(function () {
  'use strict';
  if (window.__kkCollection) { window.__kkCollection.scan(); return; }

  var VIEW_KEY = 'kk_collection_view';
  var SIZES = {
    dense: '(min-width: 1100px) 20vw, (min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw',
    large: '(min-width: 750px) 50vw, 100vw'
  };
  var SLIDE = 500;                // the panel's own time, as in the stylesheet
  var SETTLE = 120;               // the theme swaps the grid in several steps: wait for the last
  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function root() { return document.querySelector('[data-kkc]'); }
  function grid() { return document.querySelector('ul#product-grid'); }
  function cards(scope) { return Array.prototype.slice.call((scope || document).querySelectorAll('[data-kkc-card]')); }

  /* ---------- pictures to a row ---------- */
  function storedView() {
    try { return window.localStorage.getItem(VIEW_KEY) === 'large' ? 'large' : 'dense'; } catch (e) { return 'dense'; }
  }
  function currentView() {
    var el = root();
    return el && el.classList.contains('kkc--large') ? 'large' : 'dense';
  }
  // A picture is fetched at the size its place calls for; a larger place asks again.
  function sizeImages(scope, view) {
    (scope || document).querySelectorAll('img[data-kkc-img]').forEach(function (img) {
      if (img.getAttribute('sizes') !== SIZES[view]) img.setAttribute('sizes', SIZES[view]);
    });
  }
  function firstOnScreen() {
    var bar = document.querySelector('[data-kkc-bar]');
    var under = bar ? bar.getBoundingClientRect().bottom : 0;
    var list = cards();
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.bottom > under + 1) return { card: list[i], top: r.top };
    }
    return null;
  }
  function setView(view, keep) {
    var el = root();
    if (!el) return;
    // the piece being looked at stays where it is while the rows re-form around it
    var held = keep ? firstOnScreen() : null;
    el.classList.toggle('kkc--large', view === 'large');
    el.querySelectorAll('[data-kkc-view]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-kkc-view') === view ? 'true' : 'false');
    });
    sizeImages(el, view);
    if (held && window.pageYOffset > 0) {
      var moved = held.card.getBoundingClientRect().top - held.top;
      if (Math.abs(moved) > 1) window.scrollBy(0, moved);
    }
    if (!keep) return;
    try { window.localStorage.setItem(VIEW_KEY, view); } catch (e) { /* no storage: the view holds for this page only */ }
  }

  /* ---------- cards arriving ----------
     Every card rises into place. The first five do so by the stylesheet alone, as they
     are first drawn; the others on screen follow 33ms apart once this runs, and the rest
     as they come on screen. The stylesheet holds a card back until it is marked is-in, and
     lets it through by itself if this never runs. */
  var arrivals = null;
  var ROW = 10;                   // the stagger starts again after this many: no card waits long
  var FIRST = '.kkc-grid > .kkc-card:nth-child(-n+5)';   // as in the stylesheet
  function columns() {
    var ul = grid();
    if (!ul) return 1;
    var n = window.getComputedStyle(ul).gridTemplateColumns.split(' ').filter(Boolean).length;
    return n > 0 ? n : 1;
  }
  function arrive(card, place) {
    card.style.setProperty('--kkc-i', String(place || 0));
    card.classList.add('is-arriving', 'is-in');
    card.classList.remove('is-waiting');
    // once in place the card is left alone: no transform, no delay on anything after
    setTimeout(function () { card.classList.remove('is-arriving'); card.style.removeProperty('--kkc-i'); }, 900 + (place || 0) * 33);
  }
  function watchCards(list) {
    var still = reduce.matches || designMode || !('IntersectionObserver' in window);
    if (!still && !arrivals) {
      arrivals = new IntersectionObserver(function (entries) {
        var cols = columns();
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          arrivals.unobserve(entry.target);
          var at = cards().indexOf(entry.target);
          arrive(entry.target, at > -1 ? at % cols : 0);
        });
      }, { rootMargin: '0px 0px -40px 0px' });
    }
    var place = 0;
    list.forEach(function (card) {
      if (card.__kkcSeen) return;
      card.__kkcSeen = true;
      if (still || card.matches(FIRST)) { card.classList.add('is-in'); return; }
      if (card.getBoundingClientRect().top < window.innerHeight) { arrive(card, place++ % ROW); return; }
      card.classList.add('is-waiting');
      arrivals.observe(card);
    });
  }
  // A grid that has been swapped out takes its cards with it: the watch is let go too, or
  // every card that never came on screen would be kept for as long as the page is open.
  function forgetCards() {
    if (arrivals) arrivals.disconnect();
    arrivals = null;
  }
  // if the observer never calls, nothing on screen stays invisible
  function arriveOnScreen() {
    cards().forEach(function (card) {
      if (card.classList.contains('is-waiting') && card.getBoundingClientRect().top < window.innerHeight) arrive(card);
    });
  }

  /* ---------- the second photograph ----------
     Under a pointer a card turns to its second photograph by itself, and back when the
     pointer leaves — until its photographs are moved by hand, after which it is left where
     it was put. */
  var over = null;
  function trackOf(card) { return card ? card.querySelector('[data-swipe-track]') : null; }
  function fetchSlides(track) {
    track.querySelectorAll('img[data-cs-src]').forEach(function (img) {
      // waits over a shimmer until its file is here, then fades in (assets/kk-page.css)
      img.setAttribute('data-cs-wait', '');
      var done = function () { img.removeAttribute('data-cs-wait'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      if (img.getAttribute('data-cs-srcset')) img.setAttribute('srcset', img.getAttribute('data-cs-srcset'));
      img.setAttribute('src', img.getAttribute('data-cs-src'));
      img.removeAttribute('data-cs-src');
      img.removeAttribute('data-cs-srcset');
    });
  }
  function turn(card) {
    var track = trackOf(card);
    // Where the photographs stand is not asked: until they are moved by hand they are only
    // ever where this put them, and may still be on their way back from the last visit.
    if (!track || card.__kkcByHand || reduce.matches) return;
    fetchSlides(track);
    var second = track.querySelectorAll('.card-swipe__slide img')[1];
    if (!second) return;
    function go() {
      card.classList.remove('is-turning');
      if (over !== card || card.__kkcByHand) return;
      card.__kkcTurned = true;
      track.scrollTo({ left: track.clientWidth, behavior: 'smooth' });
    }
    // never onto an empty frame: the turn waits for the photograph, and while it does a
    // gleam passes over the first (kk-collection.css), so the wait is seen, not blank
    if (second.complete && second.getAttribute('src') && second.getAttribute('src').indexOf('data:') !== 0) { if (second.naturalWidth) go(); return; }
    else {
      card.classList.add('is-turning');
      second.addEventListener('load', go, { once: true });
      second.addEventListener('error', function () { card.classList.remove('is-turning'); }, { once: true });
    }
  }
  function turnBack(card) {
    if (card) card.classList.remove('is-turning');
    var track = trackOf(card);
    if (!track || !card.__kkcTurned) return;
    card.__kkcTurned = false;
    if (!card.__kkcByHand) track.scrollTo({ left: 0, behavior: 'smooth' });
  }
  function byHand(e) {
    var card = e.target.closest ? e.target.closest('[data-kkc-card]') : null;
    if (!card || !e.target.closest('[data-card-swipe]')) return;
    // two fingers across a trackpad move the photographs too; up and down is the page scrolling
    if (e.type === 'wheel' && Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    card.__kkcByHand = true;
    card.__kkcTurned = false;
  }

  /* ---------- more pieces ---------- */
  function idle() { return { io: null, mark: null, watch: null, grid: null, asking: null, busy: false, done: false, page: 1, total: 1 }; }
  var more = idle();

  function pagesOf(ul) {
    var total = parseInt(ul.getAttribute('data-total-pages'), 10);
    var current = parseInt(ul.getAttribute('data-current-page'), 10);
    return total > 0 && current > 0 ? { total: total, current: current } : null;
  }
  function numbered(ul) { return ul.parentNode.querySelector('.pagination-wrapper'); }
  function foot(ul) {
    var line = ul.parentNode.querySelector('[data-kkc-foot]');
    if (!line) return;
    var first = parseInt(ul.getAttribute('data-first'), 10) || 1;
    var total = parseInt(ul.getAttribute('data-total'), 10) || 0;
    var shown = cards(ul).length;
    if (!total || !shown) { line.hidden = true; return; }
    var last = Math.min(total, first + shown - 1);
    var noun = ul.getAttribute('data-noun') || 'product';
    line.textContent = 'You’re viewing ' + first + '–' + last + ' of ' + total + ' ' + noun + (total === 1 ? '' : 's');
    line.hidden = false;
  }
  function disarm() {
    if (more.io) more.io.disconnect();
    if (more.asking) more.asking.abort();             // a page still on its way is no longer wanted
    [more.mark, more.watch].forEach(function (el) { if (el && el.parentNode) el.parentNode.removeChild(el); });
    more = idle();
  }
  function arm() {
    disarm();
    var ul = grid();
    if (!ul) return;
    more.grid = ul;
    foot(ul);
    var info = pagesOf(ul);
    var nav = numbered(ul);
    // The numbered pages go only when this can stand in for them, and only from the first
    // page: arriving on a later one, they are the way back to the pages before it.
    if (!info || !('IntersectionObserver' in window)) { if (nav) nav.style.display = ''; return; }
    more.page = info.current;
    more.total = info.total;
    more.done = info.current >= info.total;
    if (nav) nav.style.display = info.current === 1 ? 'none' : '';
    if (more.done) return;

    var mark = document.createElement('div');
    mark.className = 'kkc-more';
    mark.setAttribute('hidden', '');
    mark.innerHTML = '<span class="kkc-more__line" role="status" aria-label="Loading more products"></span>';
    ul.parentNode.insertBefore(mark, ul.nextSibling);
    // a hidden element is never "on screen": the watch is kept on a line of its own
    var watch = document.createElement('span');
    watch.setAttribute('aria-hidden', 'true');
    watch.style.cssText = 'display:block;height:1px;';
    mark.parentNode.insertBefore(watch, mark);
    more.mark = mark;
    more.watch = watch;
    more.io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) loadNext();
    }, { rootMargin: '600px 0px' });
    more.io.observe(watch);
  }
  function loadNext() {
    if (more.busy || more.done || !more.grid) return;
    var ul = more.grid, mine = more;
    mine.busy = true;
    mine.io.unobserve(mine.watch);
    mine.mark.removeAttribute('hidden');
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(mine.page + 1));
    url.searchParams.set('section_id', ul.getAttribute('data-id'));
    mine.asking = 'AbortController' in window ? new AbortController() : null;
    fetch(url.toString(), { headers: { Accept: 'text/html' }, signal: mine.asking ? mine.asking.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('page'); return r.text(); })
      .then(function (text) {
        if (more !== mine) return;                    // the grid was swapped while this was on its way
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('ul#product-grid');
        var items = fresh ? Array.prototype.slice.call(fresh.children) : [];
        if (!items.length) { mine.done = true; return; }
        var added = items.map(function (li) { return document.importNode(li, true); });
        var piece = document.createDocumentFragment();
        added.forEach(function (li) { piece.appendChild(li); });
        ul.appendChild(piece);
        mine.page += 1;
        ul.setAttribute('data-current-page', String(mine.page));
        if (mine.page >= mine.total) mine.done = true;
        dress(ul, added);
        foot(ul);
      })
      .catch(function () {
        // the way on must never be lost: if a page cannot be fetched, the numbered pages come back
        if (more !== mine) return;
        mine.done = true;
        var nav = numbered(ul);
        if (nav) nav.style.display = '';
      })
      .then(function () {
        if (more !== mine) return;
        mine.busy = false;
        mine.asking = null;
        mine.mark.setAttribute('hidden', '');
        if (mine.done) { mine.io.disconnect(); return; }
        // let the new rows take their place before looking again
        setTimeout(function () { if (more === mine && !mine.done) mine.io.observe(mine.watch); }, 300);
      });
  }

  // whatever a fresh set of cards needs: the view's picture sizes, the swipe, the
  // photographs that were already there before anyone listened for them, the arrival
  function dress(scope, list) {
    sizeImages(scope, currentView());
    if (window.__initCardSwipe) window.__initCardSwipe(scope);
    if (window.__kkPage) window.__kkPage.images(scope);
    watchCards(list || cards(scope));
  }
  // A grid swapped in by a filter starts at its top: left where the page was, the visitor
  // would be looking at the middle of something else.
  function toTop(ul) {
    var bar = document.querySelector('[data-kkc-bar]');
    if (!bar) return;
    var top = ul.getBoundingClientRect().top;
    if (top >= bar.getBoundingClientRect().bottom - 1) return;   // its top is already in sight
    // Going up the page brings the header back, and the bar comes down under it: the first
    // row is put where it will clear them both.
    var head = document.querySelector('.section-header .header-wrapper');
    var clear = bar.offsetHeight + (head ? head.offsetHeight : 0);
    window.scrollBy({ top: top - clear, behavior: reduce.matches ? 'auto' : 'smooth' });
  }

  /* ---------- Filter & Sort ---------- */
  var drawer = null, opener = null, closing = 0, lastInput = '';

  function panel() { return drawer ? drawer.querySelector('[data-kkc-panel]') : null; }
  function reachable() {
    var p = panel();
    if (!p) return [];
    return Array.prototype.slice.call(p.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary'))
      .filter(function (el) { return el.offsetParent !== null || el.getClientRects().length > 0; });
  }
  function openDrawer(from) {
    if (!drawer || drawer.classList.contains('is-open')) return;
    clearTimeout(closing);
    opener = from || document.activeElement;
    drawer.removeAttribute('hidden');
    void drawer.offsetWidth;                          // commit the shut state so the slide plays
    drawer.classList.add('is-open');
    html.classList.add('kkc-is-open');
    document.querySelectorAll('[data-kkc-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var p = panel();
    if (p) p.focus({ preventScroll: true });
  }
  function closeDrawer(keepFocus) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    html.classList.remove('kkc-is-open');
    document.querySelectorAll('[data-kkc-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var mine = drawer;
    closing = setTimeout(function () { if (!mine.classList.contains('is-open')) mine.setAttribute('hidden', ''); }, reduce.matches ? 160 : SLIDE);
    if (!keepFocus && opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
  }
  function wireDrawer() {
    var found = document.querySelector('[data-kkc-drawer]');
    if (!found) { drawer = null; html.classList.remove('kkc-is-open'); return; }
    if (found.__kkcWired) { drawer = found; return; }
    found.__kkcWired = true;
    drawer = found;
    html.classList.remove('kkc-is-open');
    var form = drawer.querySelector('form');
    if (!form) return;
    // Enter in a price field would send the form the old way, to a page of its own
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    form.addEventListener('input', function (e) { lastInput = e.target && e.target.id ? e.target.id : ''; });
    // The theme swaps the list being used for a freshly counted one, and the box that had
    // the keyboard goes with it. Its twin in the new list takes the keyboard back.
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (!lastInput || !drawer.classList.contains('is-open')) return;
        var p = panel();
        if (p && p.contains(document.activeElement) && document.activeElement !== p) return;
        var twin = document.getElementById(lastInput);
        if (twin && !twin.disabled) twin.focus({ preventScroll: true });
      }).observe(form, { childList: true, subtree: true });
    }
  }

  /* ---------- clicks, keys, pointer ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-kkc-view], [data-kkc-open], [data-kkc-close]') : null;
    if (!t) return;
    if (t.hasAttribute('data-kkc-view')) { setView(t.getAttribute('data-kkc-view') === 'large' ? 'large' : 'dense', true); return; }
    if (t.hasAttribute('data-kkc-open')) { openDrawer(t); return; }
    closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var list = reachable();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], at = document.activeElement;
    if (list.indexOf(at) === -1) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && at === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && at === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('mouseover', function (e) {
    if (!pointer.matches) return;                     // a touch screen swipes; nothing turns by itself
    var card = e.target.closest ? e.target.closest('[data-kkc-card]') : null;
    if (card === over) return;
    var left = over;
    over = card;
    if (left) turnBack(left);
    if (card) turn(card);
  });
  document.documentElement.addEventListener('mouseleave', function () { var left = over; over = null; if (left) turnBack(left); });
  document.addEventListener('pointerdown', byHand, true);
  document.addEventListener('wheel', byHand, { capture: true, passive: true });
  window.addEventListener('pageshow', function (e) { if (e.persisted) closeDrawer(true); });

  /* ---------- the grid, each time it is new ---------- */
  function scan() {
    var el = root();
    if (!el) { disarm(); forgetCards(); drawer = null; html.classList.remove('kkc-is-open'); return; }
    setView(storedView(), false);
    wireDrawer();
    var ul = grid();
    if (ul) dress(ul);
    if (ul !== more.grid) arm();
    watchGrid();
  }
  // The theme's filters swap the inside of #ProductGridContainer: the new grid needs
  // everything the first one had.
  function watchGrid() {
    var box = document.getElementById('ProductGridContainer');
    if (!box || box.__kkcWatched || !('MutationObserver' in window)) return;
    box.__kkcWatched = true;
    var timer = 0;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var ul = grid();
        if (!ul) { disarm(); forgetCards(); return; }
        if (ul !== more.grid) { forgetCards(); toTop(ul); dress(ul); arm(); }
      }, SETTLE);
    }).observe(box, { childList: true, subtree: true });
  }

  window.__kkCollection = { scan: scan, open: openDrawer, close: closeDrawer, view: setView };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', function () { setTimeout(scan, 0); });
  setTimeout(arriveOnScreen, 2500);
})();
